import { Children, cloneElement, isValidElement } from 'react';
import hasComplexChildren from './hasComplexChildren.js';
const deepMap = (children, deepMapFn) => Children.toArray(children).map((child, index, mapChildren) => {
    if (isValidElement(child) && hasComplexChildren(child)) {
        // Clone the child that has children and map them too
        return deepMapFn(cloneElement(child, {
            ...child.props,
            children: deepMap(child.props.children, deepMapFn),
        }));
    }
    return deepMapFn(child, index, mapChildren);
});
export default deepMap;
//# sourceMappingURL=deepMap.js.map